import { render, staticRenderFns } from "./SustainabilityScore.vue?vue&type=template&id=083eb67e&scoped=true&"
import script from "./SustainabilityScore.vue?vue&type=script&lang=js&"
export * from "./SustainabilityScore.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilityScore.vue?vue&type=style&index=0&id=083eb67e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083eb67e",
  null
  
)

export default component.exports